import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { DocumentInput } from '../../atoms/DocumentInput/DocumentInput'
import { isValidDocument, getMaskedDocument } from '../../../util/document'
import { PersonalDataTooltip } from '../PersonalDataTooltip'

export const CpfInput = ({ control, reset, value, clearErrors, type, isLoadingDocument }) => {
  useEffect(() => {
    const isTruthType = type === 'cpf'

    value &&
      isTruthType &&
      reset({
        cnpj: '',
        cpf: getMaskedDocument(value),
      })
  }, [value])

  return (
    <Controller
      name="cpf"
      control={control}
      rules={{
        validate: cpf => isValidDocument(cpf, 'cpf'),
      }}
      render={({ field, fieldState }) => (
        <DocumentInput
          {...field}
          {...fieldState}
          placeholder="000.000.000-00"
          state={fieldState.isDirty && !!fieldState.error && 'error'}
          stateMessage="Insira um CPF válido."
          onFocus={() => clearErrors('cpf')}
          link={<PersonalDataTooltip />}
          disabled={isLoadingDocument}
        />
      )}
    />
  )
}
